import React from 'react';

import Field from '../layout/Field.jsx';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListSubheader from '@mui/material/ListSubheader';

const SettingsSection = ({
	Registry,
	fields = [],
	values,
	errors,
	onChange,
	columns = [],
	readOnly,
	disabled,
	labelWidth,
	padding = 0,
}) => {
	const cols = [...columns];
	if(fields.length) cols.push({ fields });

	return (
		<Box sx={{ maxWidth: '100%', display: 'flex', flexDirection: 'row', gap: 2, flexWrap: 'wrap', padding }}>
			{cols?.map((c, id) => 
				<Box key={`col-${id}`} sx={{ minWidth: '30%', flex: 1, display: 'flex', flexDirection: 'column', gap: 2 , ...(c.sx || {}) }} >
					{c.fields?.map((field, i) => {
						const { rowLabel, rowDescription, rowLabelHeight, ...fieldProps } = field;
						const key = `${field.name}-${i}`;
						const required = !readOnly 
							&& !field.readOnly 
							&& field.required 
							&& '*';
			

						if(field.type === 'SettingsHeader') return (
							<ListSubheader key={key} sx={{
								padding: 0,
							}}>
								{field.title}
							</ListSubheader>);
							
						return (
							<Box key={key} sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
								<Box sx={{ width: labelWidth || '30%', flexGrow: 0, flexShrink: 0 }}>
									<Typography 
										variant='body2' 
										sx={{ height: rowLabelHeight || 'initial', display: 'flex', alignItems: 'end', justifyContent: 'space-between' }}
									>{rowLabel} {required}</Typography>
									{!!rowDescription && <Typography variant='caption' sx={{ opacity: 0.4 }}>{rowDescription}</Typography>}
								</Box>
								{/* https://css-tricks.com/flexbox-truncated-text/ */}
								<Box sx={{ flex: 2, minWidth: 0 }}>
									<Field 
										Registry={Registry}
										size='small'
										{...fieldProps}
										onChange={onChange}
										values={values}
										errors={errors}
										readOnly={readOnly || field.readOnly}
										disabled={disabled || field.disabled}
									/>
								</Box>
							</Box>);},
					)}
				</Box>,
			)}
		</Box>
	);
};

SettingsSection.type = 'SettingsSection';
SettingsSection.hasNavigation = true;

export default SettingsSection;